import Dashboard from "../pages/dashboard";
import Grade from "../pages/grade";
import AddGrade from "../pages/grade/add";
import SearchLedger from "../pages/ledger/SearchLedger";
import Supplier from "../pages/suppliers";
import AddSupplier from "../pages/suppliers/add";
import Party from "../pages/party";
import AddParty from "../pages/party/add";
import CashSales from "../pages/cashsales";
import AddCashSales from "../pages/cashsales/add";
import Product from "../pages/product";
import AddProduct from "../pages/product/add";
import ViewStock from "../pages/product/viewStock";
import SubProduct from "../pages/subproduct";
import AddSubProduct from "../pages/subproduct/add";
import AddInvoice from "../pages/invoice/add";
import Invoices from "../pages/invoice";
import AddSalesPendingOrders from "../pages/salespending/add";
import SalesPendingOrders from "../pages/salespending";
import AddProforma from "../pages/proforma/add";
import Proforma from "../pages/proforma";
import ViewProforma from "../pages/proforma/view";
import AddSampleBrackage from "../pages/samplebrackage/add";
import SampleBrackage from "../pages/samplebrackage";
import Terms from "../pages/terms";
import AddTerms from "../pages/terms/add";
import ContactPersons from "../pages/contactpersons";
import AddContactPersons from "../pages/contactpersons/add";
import Banks from "../pages/banks";
import AddBanks from "../pages/banks/add";
import Profile from "../pages/settings/profile";
import Pdf from "../shared/pdf";
import SalesReturn from "../pages/salesreturn";
import AddSalesReturn from "../pages/salesreturn/add";
import Transport from "../pages/transport";
import AddTransport from "../pages/transport/add";
import Payment from "../pages/payment";
import AddPayment from "../pages/payment/add";
import Posts from "../pages/posts";
import AddPosts from "../pages/posts/add";
import Catalogue from "../pages/catalogue";
import AddCatalogue from "../pages/catalogue/add";
import OrderPermission from "../pages/permission/orderPermission";
import Vehicles from "../pages/vehicles";
import AddVehicle from "../pages/vehicles/add";
import Workers from "../pages/workers";
import AddWorker from "../pages/workers/add";
import AddPurchase from "../pages/purchase/add";
import Purchase from "../pages/purchase";
import AddPurchaseReturn from "../pages/purchasereturn/add";
import PurchaseReturn from "../pages/purchasereturn";
import ViewPurchase from "../pages/purchase/view";
import ChangePassword from "../pages/settings/changePassword";
import AddProductImage from "../pages/product/addProductImage";
import PurchaseOrder from "../pages/purchaseorder";
import AddPurchaseOrder from "../pages/purchaseorder/add";
import ViewPurchaseOrder from "../pages/purchaseorder/view";
import SearchOutStanding from "../pages/ledger/SearchOutStanding";

const DealerRoutes = [

  { path: "", component: <Dashboard /> },
  { path: "dashboard", component: <Dashboard /> },

  { path: "settings/vehicles", component: <Vehicles /> },
  { path: "settings/vehicles/add", component: <AddVehicle /> },
  { path: "settings/vehicles/edit/:id", component: <AddVehicle /> },

  { path: "settings/workers", component: <Workers /> },
  { path: "settings/workers/add", component: <AddWorker /> },
  { path: "settings/workers/edit/:id", component: <AddWorker /> },

  { path: "product", component: <Product /> },
  { path: "product/images", component: <Product /> },
  { path: "product/add", component: <AddProduct /> },
  { path: "product/add-image", component: <AddProductImage /> },
  { path: "product/edit/:id", component: <AddProduct /> },
  { path: "product/sub-product", component: <SubProduct /> },
  { path: "product/sub-product/add", component: <AddSubProduct /> },
  { path: "product/sub-product/edit/:id", component: <AddSubProduct /> },
  { path: "product/stock", component: <ViewStock /> },

  { path: "grade", component: <Grade /> },
  { path: "grade/add", component: <AddGrade /> },
  { path: "grade/edit/:id", component: <AddGrade /> },
  { path: "payments/party-payment-ledger", component: <SearchLedger /> },
  { path: "payments/outstanding", component: <SearchOutStanding /> },

  { path: "sales/party", component: <Party /> },
  { path: "sales/party/add", component: <AddParty /> },
  { path: "sales/party/edit/:id", component: <AddParty /> },
  { path: "sales/cash-sales", component: <CashSales /> },
  { path: "sales/cash-sales/add", component: <AddCashSales /> },
  { path: "sales/cash-sales/edit/:id", component: <AddCashSales /> },
  { path: "sales/invoices", component: <Invoices /> },
  { path: "sales/invoices/add", component: <AddInvoice /> },
  { path: "sales/invoices/edit/:id", component: <AddInvoice /> },
  { path: "sales/view/:id", component: <Pdf /> },
  { path: "sales/proforma", component: <Proforma /> },
  { path: "sales/proforma/add", component: <AddProforma /> },
  { path: "sales/proforma/edit/:id", component: <AddProforma /> },
  { path: "proforma/view/:id", component: <ViewProforma /> },
  { path: "invoice/view/:id", component: <Pdf /> },
  { path: "sales/pending-orders", component: <SalesPendingOrders /> },
  { path: "sales/pending-orders/add", component: <AddSalesPendingOrders /> },
  { path: "sales/pending-orders/edit/:id", component: <AddSalesPendingOrders /> },
  { path: "sales-return", component: <SalesReturn /> },
  { path: "sales-return/add", component: <AddSalesReturn /> },
  { path: "sales-return/edit/:id", component: <AddSalesReturn /> },
  { path: "sales/sample-brackage", component: <SampleBrackage /> },
  { path: "sales/sample-brackage/add", component: <AddSampleBrackage /> },
  { path: "sales/sample-brackage/edit/:id", component: <AddSampleBrackage /> },

  { path: "purchase/suppliers", component: <Supplier /> },
  { path: "purchase/suppliers/add", component: <AddSupplier /> },
  { path: "purchase/suppliers/edit/:id", component: <AddSupplier /> },

  { path: "purchase", component: <Purchase /> },
  { path: "purchase/add", component: <AddPurchase /> },
  { path: "purchase/edit/:id", component: <AddPurchase /> },
  { path: "purchase/view/:id", component: <ViewPurchase /> },

  { path: "purchase-return", component: <PurchaseReturn /> },
  { path: "purchase-return/add", component: <AddPurchaseReturn /> },
  { path: "purchase-return/edit/:id", component: <AddPurchaseReturn /> },

  { path: "purchase-order", component: <PurchaseOrder /> },
  { path: "purchase-order/add", component: <AddPurchaseOrder /> },
  { path: "purchase-order/edit/:id", component: <AddPurchaseOrder /> },
  { path: "purchase-order/view/:id", component: <ViewPurchaseOrder /> },


  { path: "payments", component: <Payment /> },
  { path: "payments/add", component: <AddPayment /> },
  { path: "payments/edit/:id", component: <AddPayment /> },

  { path: "settings/catalogue", component: <Catalogue /> },
  { path: "settings/catalogue/add", component: <AddCatalogue /> },
  { path: "settings/catalogue/edit/:id", component: <AddCatalogue /> },

  { path: "settings/transport", component: <Transport /> },
  { path: "settings/transport/add", component: <AddTransport /> },
  { path: "settings/transport/edit/:id", component: <AddTransport /> },

  { path: "settings/banks", component: <Banks /> },
  { path: "settings/banks/add", component: <AddBanks /> },
  { path: "settings/banks/edit/:id", component: <AddBanks /> },

  { path: "settings/terms", component: <Terms /> },
  { path: "settings/terms/add", component: <AddTerms /> },
  { path: "settings/terms/edit/:id", component: <AddTerms /> },

  { path: "settings/contact-persons", component: <ContactPersons /> },
  { path: "settings/contact-persons/add", component: <AddContactPersons /> },
  { path: "settings/contact-persons/edit/:id", component: <AddContactPersons /> },

  { path: "settings/profile", component: <Profile /> },
  { path: "settings/change-password", component: <ChangePassword /> },

  { path: "settings/order-permission", component: <OrderPermission /> },

  { path: "posts", component: <Posts /> },
  { path: "posts/add", component: <AddPosts /> },
  { path: "posts/edit/:id", component: <AddPosts /> },
];

export default DealerRoutes;
